import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

import { OWNERSHIP_FILTER_OPTIONS, type IOwnershipFilter } from '../model';

type Props = {
  value: IOwnershipFilter;
  onValueChange: (value: IOwnershipFilter) => void;
  'aria-label': string;
};

const OwnershipFilterSelect = ({ value, onValueChange, 'aria-label': ariaLabel }: Props) => {
  const handleValueChange = (nextValue: string) => onValueChange(nextValue as IOwnershipFilter);

  return (
    <Select value={value} onValueChange={handleValueChange}>
      <SelectTrigger className="w-full shrink-0 sm:w-45" aria-label={ariaLabel}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {OWNERSHIP_FILTER_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default OwnershipFilterSelect;
